module.exports = __webpack_public_path__ + "img/4.f138d817.jpg";